var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGwc = function SvgGwc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2E2D37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.282 16.954c-.533 0-.99-.38-1.088-.906L2.553 2.935a.25.25 0 0 0-.11-.127.248.248 0 0 0-.192-.027A1.106 1.106 0 1 1 1.68.644a2.448 2.448 0 0 1 1.87.248 2.449 2.449 0 0 1 1.169 1.581l1.486 12.269h12.14a1.106 1.106 0 1 1 0 2.212H5.282Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3 12.45c-.04-.61.42-1.097 1.03-1.138l9.66-.632a.845.845 0 0 1 .074-.003.256.256 0 0 0 .253-.253c0-.026 0-.053.002-.079l.28-4.297a.257.257 0 0 0-.25-.23h-.051L4.213 5.56c-.61-.028-1.082-.383-1.055-.993a1.106 1.106 0 0 1 1.156-1.055l13.87.256a2.468 2.468 0 0 1 2.433 2.545l-.282 4.052a2.468 2.468 0 0 1-2.423 2.42l-9.434.63-.075.002c-.577 0-1.064-.382-1.103-.967Zm9.107 8.618a1.738 1.738 0 1 1 0-3.477 1.738 1.738 0 0 1 0 3.477Zm-7.62-1.738a1.738 1.738 0 1 1-3.477 0 1.738 1.738 0 0 1 3.477 0Z"
  }))));
};

export default SvgGwc;